export var ToastItemStatus;
(function (ToastItemStatus) {
    ToastItemStatus[ToastItemStatus["Loaded"] = 0] = "Loaded";
    ToastItemStatus[ToastItemStatus["Visible"] = 1] = "Visible";
    ToastItemStatus[ToastItemStatus["Closed"] = 2] = "Closed";
})(ToastItemStatus || (ToastItemStatus = {}));
//# sourceMappingURL=types.js.map